import { SwapCard } from "./SwapCard";

export function SwapPage() {
  return (
    <div className="flex flex-col items-center justify-start pt-12 pb-20 px-4 min-h-[calc(100vh-4rem)]">
      <div className="text-center mb-8">
        <h1 className="font-display text-3xl font-bold gradient-text mb-2">
          Swap Tokens
        </h1>
        <p className="text-text-secondary text-sm">
          Trade tokens instantly on JasmyChain
        </p>
      </div>
      <SwapCard />
    </div>
  );
}
